<template>
    <div>
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;border-bottom:2px solid #389;padding-top:3px">
            <div style="min-width:1100px;display:flex">
                <div style="width:100px;display:flex" >
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px; ">新增记录</span></el-link>
                </div>
                <div style="width:100px;display:flex" >
                    <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:14px;margin-right:5px; "></i>
                    <el-link :disabled="addBool" @click="cpRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">生成假期</span></el-link>
                </div>
                <div style="width:60px;font-size:12px" >查询字段 </div>
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;  ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:310px;margin-left:2px;height:30px;  ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input> 
                <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam2" size="small" style="width:310px;margin-left:2px;height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                </el-input>
            </div>
        </div> 
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:1px;"
                size="small"
                v-loading="v_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :height="tabHeight" 
                :row-key="getRowKey"  
                ref="tabref" 
                highlight-current-row>
                <el-table-column label="序号" width="55" type="index"></el-table-column>
                <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                    :min-width="item.width">
                    <template   slot-scope="scope" >
                        <el-checkbox v-if="item.edcss==='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                        <span v-else v-text="scope.row[item.key]"></span>
                    </template>
                </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="185">
                <template slot-scope="scope">
                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="stfgRec(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:5px;">发起审批 </span></el-link>  
                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="editRec(scope.row,'N')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">编辑 </span></el-link>  
                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="cancelBool" @click="delRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:11px; ">删除 </span></el-link>
                </template>
            </el-table-column>                      
        </el-table>  
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto">
                <Form :model="perRow" :label-width="120"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem    :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <template slot="label"><span v-if="item.notnull=='Y'" style="color:red;margin-right:8px">*</span>{{item.title}}</template>
                            <el-date-picker :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="perRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number :disabled="saveFlag"  v-else-if="item.edcss==='number'" v-model="perRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-checkbox border :disabled="item.disabled=='Y'" v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="perRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-time-select v-else-if="item.edcss==='time'" :disabled="saveFlag " v-model="perRow[item.key]" :picker-options="{ start: '06:30',step: '00:15',end: '23:30'}" placeholder="请选择时间" style="width:100%"></el-time-select>
                            <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="perRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">   
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="drawer=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  :disabled="saveFlag?true:false" @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 产生假期 -->
        <el-dialog v-dialogDrag :visible.sync="cpWin"  width="600px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">生成假期</span>
            </div>
            <div style="line-height:30px ;height:60px;display:flex">
                 <div style="height:30px;line-height:30px;width:80px" >年份</div>
                 <el-select   v-model="v_year"   style="width:100%">
                    <el-option v-for="(item,index) in yrArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                 </el-select>
            </div>
            <div style="line-height:30px ;height:60px;display:flex">
                 <div style="height:30px;line-height:30px;width:80px" >周六</div>
                 <el-checkbox  v-model="v_sat"  border true-label="Y" false-label="N" style="width:100%"> </el-checkbox>
            </div>
            <div style="line-height:30px ;height:60px;display:flex">
                 <div style="height:30px;line-height:30px;width:80px" >周日</div>
                 <el-checkbox  v-model="v_sun"  border true-label="Y" false-label="N" style="width:100%"> </el-checkbox>
            </div>
            <span slot="footer"  >
                <el-button type="info" size="small" @click="cpWin = false" style="margin-right:25px">取消</el-button>
                <el-button type="primary" size="small" @click="cpOk">确定</el-button> 
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
import { startWorkflowInstance } from '@/utils/workflowDesigner.js' 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
//局部注册
export default {
    name:"job_time",
    data () {
        return {
            drawer:false,
            perFlag:'create',
            v_loading:false,
            v_year:'',
            v_sat:'Y',
            v_sun:'Y',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            perRow:{},
 
            loadWin:false,
            cpWin:false,
            frmth:'',
            tomth:'',
            active:'', //二级菜单选中标志
            yrArr:[],
            disabled:false, //新增权限制
 
            ruleValidate:{},
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            tabData:[], //表数据
            tabArr:[], //表列 
            operArr:[],           
            comboArr:{},
            oper:'like',
            txtparam:'',
            selparam:'',
            oper2:'like',
            txtparam2:'',
            selparam2:'',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
 
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_Year','').then(res=>{
            this.yrArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','419075','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
 
        this.getDayList('')
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 120) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
           
            this.getTabField() //表列字段
   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        stfgRec(row){
            startWorkflowInstance({
                flowId: '446046',
                businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                component: this,
                axios: this.$axios,
                baseUrl: '',
                // 微信消息相关参数
                docType: '补卡申请单', // 单据类型
                DIRNM: row.DTTM, // 项目名称，使用文件名
                CNAME: row.RMK,
                businessData: {
                    flowType: 3,
                    qty: null,
                    amt: row['TTLAMT'],
                },
                jumpUrl: window.location.href // 跳转URL，使用当前页面地址
            })
            this.promptWin =true    
            this.prompt ='审批已发起！'
        },
        cpRec(){
            this.cpWin =true
            this.v_year =getDate('yr')
            this.v_sat='Y'
            this.v_sun ='Y'
        },
        cpOk(){
            this.$confirm('你确定要生成记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin =true
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/genHoliday',
                    data: {p_year:this.v_year,p_sat:this.v_sat, corpid:this.v_corpid,p_sun:this.v_sun,p_user:this.v_usernm},
                }).then(res=>{ 
                    if (res.code=='200'){
                        this.cpWin =false
                        this.qryTabData()
                        this.loadWin=false
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                        this.loadWin=false
                    }
                })              
            })
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'419075',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            //发起保存请求   
            if (this.perRow['DTTM']) {  
                let obj_ ={}      
                Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_hol'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        vm.drawer =false   
                        this.qryTabData()
                    }else{
                        if (res.result.indexOf('ORA-00001')) {
                            this.prompt='此日期已存在！'
                        }else{
                            this.prompt=res.result
                        }
                        this.promptWin=true                       
                    }        
                }) 
            }else{
                this.promptWin =true
                this.prompt ='日期不能为空'
            }
        },
 
        //假期明细
        getDayList(cond){
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond +' order by dttm',p_table:'V_BS_hol'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                    this.v_loading=false
                }else{
                    this.v_loading=false
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout();
                })
            }) 
        },
 
        editRec(row,val){
 
            this.perRow =JSON.parse(JSON.stringify(row))
            this.drawer=true           
        },
        getRowKey(row){
            return row['IDSEQ']
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            this.getDayList( cond_)
             
        },
        //新增 
        addRec(){

            this.drawer =true
 
            this.perRow={ }
            this.saveFlag=false
        
        },
        //删除记录
        delRec(row,index){
                this.$confirm('你确定要删除此行记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    //发起删除请求
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_hol'},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            this.tabData.splice(index,1)
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    })     
                }).catch(()=>{})
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','419075','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #808695;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 